import React from 'react';
import { breadcrumbsParams, getBreadcrumbs } from 'app/area/shared/codetable/breadcrumbs';
import { LinkCodesList } from './components/link-codes-list';
import { UserInfo } from 'app/types-shared';
import { RouterProps } from 'app/components/enhancers/with-router';

interface LinkCodesProps {
  userInfo?: UserInfo;
  params: breadcrumbsParams;
  router: RouterProps;
}

export function LinkCodes({ 
  userInfo: { access: { adminPanel: { codetable: { linkSubset } } } },
  params, router
}: LinkCodesProps) {
  const breadcrumbs = getBreadcrumbs(params);

  return <LinkCodesList breadcrumbs={breadcrumbs} router={router} linkSubset={linkSubset} />;
}
